import { workplaceSettingsConstants as wsc } from 'srcReact/WorkplaceSettingsPage'
import { workplaceService } from 'srcReact/services'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY
const WORKPLACE_PAGINATION_QUANTITY = appConstantSettings.WORKPLACE_PAGINATION_QUANTITY

export const workplaceSettingsActions = {
  getWorkplaceList,
  getWorkplaceManageInvites,
  getWorkplaceSettings,
  getWorkplaceGroups,
  getWorkplaceMemberLedGroups,
  getWorkplaceSettingsMembers,
  getWorkplaceSettingsMembersPagination,
  getWorkplaceMembers,
  getWorkplaceMembersPagination,
  getRightsPermissions,
  updateRightsPermissions,
  getLeadershipTeam,
  updateWorkplace,
  addWorkplaceMemberRole,
  removeWorkplaceMemberRole,
  removeWorkplaceMember,
  deleteWorkplace,
  deleteWorkplaceInvitation
}

function getWorkplaceList(organization_id) {
  return (dispatch) => {
    dispatch(request({ organization_id }))

    workplaceService.getWorkplaceList({ organization_id }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_LIST_FAILURE, error }
  }
}

function getWorkplaceManageInvites(
  workplace_id,
  status = 'pending',
  search = '',
  orderby = 'lastSent',
  isPagination,
  offset = 0,
  quantity = WORKPLACE_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ workplace_id, status, search, orderby, isPagination, offset, quantity }))

    workplaceService.getWorkplaceManageInvites({ workplace_id, status, search, orderby, offset, quantity }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_MANAGE_INVITES_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_MANAGE_INVITES_SUCCESS, data: { ...data, status, isPagination } }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_MANAGE_INVITES_FAILURE, error }
  }
}

function getLeadershipTeam(workplace_id, search = '', with_photo = 0, photo_size = 80) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id,
        search,
        with_photo,
        photo_size
      })
    )

    workplaceService
      .getLeadershipTeam({
        workplace_id,
        search,
        with_photo,
        photo_size
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_LEADERSHIP_TEAM_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_LEADERSHIP_TEAM_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_LEADERSHIP_TEAM_FAILURE, error }
  }
}

function getWorkplaceSettingsMembers(
  workplace_id,
  search = '',
  orderby = 'lastname',
  shared_interests_count = 0,
  with_photo = 0,
  photo_size = 80,
  exclude_managers = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id,
        search,
        orderby,
        shared_interests_count,
        with_photo,
        photo_size,
        exclude_managers,
        offset,
        quantity
      })
    )

    workplaceService
      .getWorkplaceSettingsMembers({
        workplace_id,
        search,
        orderby,
        shared_interests_count,
        with_photo,
        photo_size,
        exclude_managers,
        offset,
        quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_FAILURE, error }
  }
}

function getWorkplaceSettingsMembersPagination(
  workplace_id,
  search = '',
  orderby = 'lastname',
  shared_interests_count = 0,
  with_photo = 0,
  photo_size = 80,
  exclude_managers = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id,
        search,
        orderby,
        shared_interests_count,
        with_photo,
        photo_size,
        exclude_managers,
        offset,
        quantity
      })
    )

    workplaceService
      .getWorkplaceSettingsMembers({
        workplace_id,
        search,
        orderby,
        shared_interests_count,
        with_photo,
        photo_size,
        exclude_managers,
        offset,
        quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_FAILURE, error }
  }
}

function getWorkplaceMembers(
  workplace_id,
  scope = 'all',
  search = '',
  orderby = 'firstname',
  with_memberinterests = 0,
  with_photo = 0,
  photo_size = 80,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id,
        scope,
        search,
        orderby,
        with_memberinterests,
        with_photo,
        photo_size,
        offset,
        quantity
      })
    )

    workplaceService
      .getWorkplaceMembers({
        workplace_id,
        scope,
        search,
        orderby,
        with_memberinterests,
        with_photo,
        photo_size,
        offset,
        quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_FAILURE, error }
  }
}

function getWorkplaceMembersPagination(
  workplace_id,
  scope = 'all',
  search = '',
  orderby = 'firstname',
  with_memberinterests = 0,
  with_photo = 0,
  photo_size = 80,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id,
        scope,
        search,
        orderby,
        with_memberinterests,
        with_photo,
        photo_size,
        offset,
        quantity
      })
    )

    workplaceService
      .getWorkplaceMembers({
        workplace_id,
        scope,
        search,
        orderby,
        with_memberinterests,
        with_photo,
        photo_size,
        offset,
        quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_MEMBERS_PAGINATION_FAILURE, error }
  }
}

function getWorkplaceSettings(workplace_id) {
  return (dispatch) => {
    dispatch(
      request({
        workplace_id
      })
    )

    workplaceService.getWorkplaceSettings(workplace_id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_SETTINGS_FAILURE, error }
  }
}

function updateWorkplace({ workplace_id, name, color, accronym, location }) {
  return (dispatch) => {
    dispatch(request({ workplace_id, name, color, accronym, location }))
    workplaceService.updateWorkplace({ workplace_id, name, color, accronym, location }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.UPDATE_WORKPLACE_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.UPDATE_WORKPLACE_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.UPDATE_WORKPLACE_FAILURE, error }
  }
}

function getWorkplaceGroups(workplace_id, scope = 'all', offset = 0, quantity = WORKPLACE_PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ workplace_id, scope, offset, quantity }))

    workplaceService.getWorkplaceGroups({ workplace_id, scope, offset, quantity }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_GROUPS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_GROUPS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_GROUPS_FAILURE, error }
  }
}

function getWorkplaceMemberLedGroups(
  workplace_id,
  scope = 'member_led_groups',
  offset = 0,
  quantity = WORKPLACE_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ workplace_id, scope, offset, quantity }))

    workplaceService.getWorkplaceGroups({ workplace_id, scope, offset, quantity }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_FAILURE, error }
  }
}

function getRightsPermissions(workplaceId) {
  return (dispatch) => {
    dispatch(request({ workplaceId }))

    workplaceService.getRightsPermissions(workplaceId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.GET_RIGHTS_PERMISSIONS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.GET_RIGHTS_PERMISSIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.GET_RIGHTS_PERMISSIONS_FAILURE, error }
  }
}

function updateRightsPermissions({ workplace_id, name, can_create_groups = 1 }) {
  return (dispatch) => {
    dispatch(request({ workplace_id, name, can_create_groups }))
    workplaceService.updateWorkplace({ workplace_id, name, can_create_groups }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_FAILURE, error }
  }
}

function addWorkplaceMemberRole(workplace_id, user_ids, role, action) {
  return (dispatch) => {
    dispatch(request({ workplace_id, user_ids, role, action }))
    workplaceService.updateRole(workplace_id, user_ids, role, action).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.ADD_WORKPLACE_MEMBER_ROLE_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.ADD_WORKPLACE_MEMBER_ROLE_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.ADD_WORKPLACE_MEMBER_ROLE_FAILURE, error }
  }
}

function removeWorkplaceMemberRole(workplace_id, user_ids, role, action) {
  return (dispatch) => {
    dispatch(request({ workplace_id, user_ids, role, action }))
    workplaceService.updateRole(workplace_id, user_ids, role, action).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_ROLE_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_ROLE_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_ROLE_FAILURE, error }
  }
}

function removeWorkplaceMember(workplace_id, user_id, dashboard = 0) {
  return (dispatch) => {
    dispatch(request({ workplace_id, user_id, dashboard }))
    workplaceService.removeWorkplaceMember({ workplace_id, user_id, dashboard }).then(
      (response) => {
        dispatch(success({ ...response, user_id }))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.REMOVE_WORKPLACE_MEMBER_FAILURE, error }
  }
}

function deleteWorkplace(workplace_id) {
  return (dispatch) => {
    dispatch(request({ workplace_id }))
    workplaceService.deleteWorkplace({ workplace_id }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.DELETE_WORKPLACE_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.DELETE_WORKPLACE_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.DELETE_WORKPLACE_FAILURE, error }
  }
}

function deleteWorkplaceInvitation(invitation_id) {
  return (dispatch) => {
    dispatch(request({ invitation_id }))
    workplaceService.deleteWorkplaceInvitation({ invitation_id }).then(
      (response) => {
        dispatch(success({ ...response, invitation_id }))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: wsc.DELETE_WORKPLACE_INVITATION_REQUEST, data }
  }
  function success(data) {
    return { type: wsc.DELETE_WORKPLACE_INVITATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: wsc.DELETE_WORKPLACE_INVITATION_FAILURE, error }
  }
}
